module.exports = __webpack_public_path__ + "img/album05_11.966623a3.jpg";